import { all } from 'redux-saga/effects'
import watcherUserSaga from './RequestsHandlers/userRequestsHandlers'
import watcherReportSaga from './RequestsHandlers/reportRequestHandler'
import watcherSecretarySaga from './RequestsHandlers/secretaryHandler'


export default function* rootSaga() {
  yield all([
    watcherUserSaga(),
    watcherReportSaga(),
    watcherSecretarySaga()
  ])
}
